import React from "react";
import PropTypes from "prop-types";
const EmployeeCount = ({ employees }) => {
  return (
    <div className="row d-flex justify-content-between align-items-center">
      {employees.map((employee, index) => (
        <div
          key={index}
          className="col-12 col-md-6 col-lg-3 mb-3"
          style={{ width: "30%" }}
        >
          <div
            className="card text-center"
            style={{ backgroundColor: employee.backgroundColor }}
          >
            <div className="card-body">
              <h5 className="card-title">{employee.residentialType}</h5>
              <p className="card-text">{employee.descriptionText}</p>
              <h2>{employee.totalCount}</h2>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmployeeCount;

EmployeeCount.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
};
